import ReminderActionModel from '@/common/models/rules/actions/reminder-action-model';

export default class RemoveReminderActionModel extends ReminderActionModel {
}
